import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=4afb6309"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports